import styled from 'styled-components';

import Button from './Button';
import { Input } from './Input';
import Tag, { TagList } from './Tag';
import Badge, { BadgeList } from './Badge';
import Spinner from './Spinner';
import Notification from './Notification';

export const DataText = styled.span`
  font-family: Courier;
  word-break: break-all;
`;

export const Avatar = styled.img<{
  size?: string;
}>`
  border: 1px ${({ theme }) => theme.colors.N40} solid;
  border-radius: 50%;
  width: ${({ size }) => size || '45px'};
  height: ${({ size }) => size || '45px'};
`;

export const StyledDate = styled.span`
  color: ${({ theme }) => theme.colors.N40};
`;

export const Separator = styled.hr`
  height: 1px;
  background: linear-gradient(
    90deg,
    rgb(9, 12, 35) 0%,
    rgb(44, 149, 205) 50%,
    rgb(9, 12, 35) 100%
  );
  border: 0;
  margin: 2.5em 0;
`;

export const HideMobile = styled.span`
  @media (max-width: ${({ theme }) => theme.breakpoint.md}) {
    display: none;
  }
`;

export { Button, Input, Tag, TagList, Badge, BadgeList, Spinner, Notification };
